import { DEFAULT_LOCALE, getLanguageAndLocaleFromUrl } from "@repo/translation";
import { logError } from "@repo/utils";

const BOKA_BASE_URL =
  import.meta.env.VITE__BOKA_BASE_URL ?? "https://ppe.boka.ingka.com";

let bokaModalLoader: Promise<void> | undefined;

const loadBokaBookingModal = (country: string, language: string) => {
  if (typeof window.boka?.bookingModal?.open === "function") {
    return Promise.resolve();
  }

  if (!bokaModalLoader) {
    const url = `${BOKA_BASE_URL}/${country}/${language}/micro-frontend/booking-modal/v0/index.js`;
    bokaModalLoader = import(/* @vite-ignore */ url)
      .then(() => {
        if (typeof window.boka?.bookingModal?.open !== "function") {
          throw new Error(
            "Boka booking modal loaded but window.boka.bookingModal.open is not available"
          );
        }
      })
      .catch((error) => {
        bokaModalLoader = undefined;
        throw error;
      });
  }

  return bokaModalLoader;
};

export const openBokaBookingModal = async (
  options: BokaBookingModalOptions
): Promise<void> => {
  const { country, language } = getLanguageAndLocaleFromUrl() ?? DEFAULT_LOCALE;

  try {
    await loadBokaBookingModal(country, language);
  } catch (error) {
    logError(error, [
      { tagName: "component", tagValue: "openBokaBookingModal" },
      { tagName: "phase", tagValue: "load" },
      { tagName: "country", tagValue: country },
      { tagName: "language", tagValue: language },
    ]);
    return;
  }

  try {
    const open = window.boka?.bookingModal?.open;
    if (typeof open !== "function") {
      throw new Error("window.boka.bookingModal.open is not available");
    }
    await open(options);
  } catch (error) {
    logError(error, [
      { tagName: "component", tagValue: "openBokaBookingModal" },
      { tagName: "phase", tagValue: "open" },
      { tagName: "country", tagValue: country },
      { tagName: "language", tagValue: language },
    ]);
  }
};
